import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-item" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "card-main" }
const _hoisted_4 = { class: "card-bottom" }
const _hoisted_5 = { class: "card-bottom-left" }

import { computed } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'CardItem',
  props: {
  src: {
    type: String,
    required: true,
  },
  checked: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '图片名称',
  },

},
  emits: ['update:checked'],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const props = __props;

let vModelChecked = computed({
  get() {
    return props.checked;
  },
  set(value) {
    emits('update:checked', value);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "content", {}, () => [
          _createVNode(_component_el_image, {
            style: {"width":"100%","height":"100%"},
            src: __props.src,
            fit: "contain"
          }, null, 8, ["src"])
        ]),
        _renderSlot(_ctx.$slots, "content-btn")
      ]),
      _renderSlot(_ctx.$slots, "shade-content")
    ]),
    _renderSlot(_ctx.$slots, "card-bottom", {}, () => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.title), 1)
      ])
    ])
  ]))
}
}

})